export default __webpack_public_path__ + "static/media/whatsapp.424dbb59.webp";